import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import LoginPanel from '../login';

const mapState = (state: any) => {
  const { userInfo } = state.common;
  return { userInfo };
};
const mapDispatch = (dispatch: any) => {
  const { getUserInfo } = dispatch.common;
  return { getUserInfo };
};

const Main = (props: any) => {
  useEffect(() => {
    handleCheckUserInfo();
  }, []);

  const handleCheckUserInfo = async () => {
    const rst = await props.getUserInfo();
    if (rst?.login) {
      window.location.href = '/app/material/material-center';
    }
  };

  if (!props.userInfo) {
    return <LoginPanel />;
  }

  return <div />;
};

export default connect(mapState, mapDispatch)(Main);
